import _defineProperty from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { SubmissionBaseQuestionPreview } from './base-question.component';
import styled from '@xstyled/styled-components';
import { Space, Col, Row } from 'antd';
import { SingleSelectInput } from '@lib/common';
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var AnswerGroup = styled(Space)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 100%;\n"])));
var AnswerItem = styled(Row)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var StyledTextDescription = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  padding: 6.5px 11px 6.5px 4px;\n  font-size: 16px;\n  margin-left: 4px;\n"])));
var StyledQuestionDescriptionWrapper = styled(Col)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n"])));
var StyledQuestionIndex = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  min-width: 32px;\n  text-align: center;\n"])));
var StyledCorrectAnswerText = styled.label(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 500;\n"])), function (props) {
  return props.$error ? props.theme.color.fontColorError : props.theme.color.fontColorSuccess;
});
export var SubmissionMatchingQuestionPreview = function SubmissionMatchingQuestionPreview(props) {
  var question = props.question,
      isSkipped = props.isSkipped,
      matchingAnswerGroup = props.answer,
      label = props.label;

  var getSavedAnswer = function getSavedAnswer(subQ) {
    var _matchingAnswerGroup$, _matchingAnswerGroup$2;

    var savedAnswer = matchingAnswerGroup === null || matchingAnswerGroup === void 0 ? void 0 : (_matchingAnswerGroup$ = matchingAnswerGroup.answers) === null || _matchingAnswerGroup$ === void 0 ? void 0 : (_matchingAnswerGroup$2 = _matchingAnswerGroup$.find(function (a) {
      return a.subQuestionId === subQ.id.toString();
    }).value) === null || _matchingAnswerGroup$2 === void 0 ? void 0 : _matchingAnswerGroup$2.answerId;
    return savedAnswer;
  };

  var renderAnswers = function renderAnswers() {
    if (isSkipped) {
      return question.subQuestions.map(function (subQ, index) {
        var _question$answers, _question$answers$fin, _question$answers$fin2;

        var answeredSubQuestion = question.correctAnswers.find(function (c) {
          return c.subQuestionId === subQ.id.toString();
        });
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsxs(AnswerItem, {
            gutter: [8, 16],
            children: [/*#__PURE__*/_jsxs(StyledQuestionDescriptionWrapper, {
              span: 18,
              children: [/*#__PURE__*/_jsxs(StyledQuestionIndex, {
                children: ["(", index + question.index, ")"]
              }), /*#__PURE__*/_jsx(StyledTextDescription, {
                children: subQ.description
              })]
            }), /*#__PURE__*/_jsx(Col, {
              span: 6,
              children: /*#__PURE__*/_jsx(SingleSelectInput, {
                disabled: true,
                options: []
              })
            })]
          }, subQ.id.toString()), ((_question$answers = question.answers) === null || _question$answers === void 0 ? void 0 : _question$answers.length) > 0 && answeredSubQuestion && /*#__PURE__*/_jsx(Row, {
            children: /*#__PURE__*/_jsx(Col, {
              span: 12,
              children: /*#__PURE__*/_jsxs(StyledCorrectAnswerText, {
                children: ["(", label.correctAnswer, ":", ' ', (_question$answers$fin = (_question$answers$fin2 = question.answers.find(function (a) {
                  return a.id.toString() === answeredSubQuestion.answerId;
                })) === null || _question$answers$fin2 === void 0 ? void 0 : _question$answers$fin2.description) !== null && _question$answers$fin !== void 0 ? _question$answers$fin : '-', ")"]
              })
            })
          })]
        });
      });
    }

    return question.subQuestions.map(function (subQ, index) {
      var _question$answers$fin3, _question$answers2;

      var answeredSubQuestion = question.correctAnswers.find(function (c) {
        return c.subQuestionId === subQ.id.toString();
      });
      var correctAnswer = question.correctAnswers.find(function (a) {
        return a.subQuestionId === subQ.id.toString();
      });
      var correctAnswerDescription = (_question$answers$fin3 = question.answers.find(function (a) {
        return a.id.toString() === (correctAnswer === null || correctAnswer === void 0 ? void 0 : correctAnswer.answerId);
      })) === null || _question$answers$fin3 === void 0 ? void 0 : _question$answers$fin3.description;
      return /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(AnswerItem, {
          gutter: [8, 16],
          children: [/*#__PURE__*/_jsxs(Col, {
            span: 1,
            children: ["(", index + question.index, ")"]
          }), /*#__PURE__*/_jsx(Col, {
            span: 17,
            children: /*#__PURE__*/_jsx(StyledTextDescription, {
              children: subQ.description
            })
          }), /*#__PURE__*/_jsx(Col, {
            span: 6,
            children: /*#__PURE__*/_jsx(SingleSelectInput, {
              defaultValue: [getSavedAnswer(subQ)],
              disabled: true,
              options: ((_question$answers2 = question.answers) === null || _question$answers2 === void 0 ? void 0 : _question$answers2.length) > 0 && question.answers.map(function (a) {
                return {
                  value: a.id.toString(),
                  label: a.description
                };
              })
            })
          })]
        }, subQ.id.toString()), correctAnswerDescription && /*#__PURE__*/_jsx(Row, {
          children: /*#__PURE__*/_jsx(Col, {
            span: 12,
            children: /*#__PURE__*/_jsxs(StyledCorrectAnswerText, {
              children: ["(", label.correctAnswer, ": ", correctAnswerDescription, ")"]
            })
          })
        })]
      });
    });
  };

  return /*#__PURE__*/_jsx(SubmissionBaseQuestionPreview, _objectSpread(_objectSpread({}, props), {}, {
    isSkipped: isSkipped,
    isEssayQuestion: true,
    children: /*#__PURE__*/_jsx(AnswerGroup, {
      direction: "vertical",
      size: "middle",
      children: renderAnswers()
    })
  }));
};